module.exports = __webpack_public_path__ + "static/media/rbaloon.fd87bbac.png";